import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface TimeFiltersProps {
  filters: {
    dateRange: string;
    project: string;
    task: string;
    user: string;
    billable: string;
  };
  onFiltersChange: (filters: any) => void;
}

const TimeFilters = ({ filters, onFiltersChange }: TimeFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4">
      {/* Date Range Filter */}
      <Select
        value={filters.dateRange}
        onValueChange={(value) => onFiltersChange({ ...filters, dateRange: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="Date Range" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="today">Today</SelectItem>
          <SelectItem value="yesterday">Yesterday</SelectItem>
          <SelectItem value="this_week">This Week</SelectItem>
          <SelectItem value="last_week">Last Week</SelectItem>
          <SelectItem value="this_month">This Month</SelectItem>
          <SelectItem value="last_month">Last Month</SelectItem>
          <SelectItem value="custom">Custom Range</SelectItem>
        </SelectContent>
      </Select>

      {/* Project Filter */}
      <Select
        value={filters.project}
        onValueChange={(value) => onFiltersChange({ ...filters, project: value })}
      >
        <SelectTrigger className="w-full md:w-[200px]">
          <SelectValue placeholder="All Projects" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Projects</SelectItem>
          <SelectItem value="1">LWM PM System</SelectItem>
          <SelectItem value="2">Barcelona E-commerce</SelectItem>
          <SelectItem value="3">Fixaro Platform</SelectItem>
        </SelectContent>
      </Select>

      {/* Task Filter */}
      <Select
        value={filters.task}
        onValueChange={(value) => onFiltersChange({ ...filters, task: value })}
      >
        <SelectTrigger className="w-full md:w-[200px]">
          <SelectValue placeholder="All Tasks" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Tasks</SelectItem>
          <SelectItem value="1">Setup authentication</SelectItem>
          <SelectItem value="2">Design dashboard</SelectItem>
          <SelectItem value="3">Fix payment gateway</SelectItem>
          <SelectItem value="4">Write API docs</SelectItem>
          <SelectItem value="5">Implement search</SelectItem>
        </SelectContent>
      </Select>

      {/* User Filter */}
      <Select
        value={filters.user}
        onValueChange={(value) => onFiltersChange({ ...filters, user: value })}
      >
        <SelectTrigger className="w-full md:w-[180px]">
          <SelectValue placeholder="All Users" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Users</SelectItem>
          <SelectItem value="1">Roman Siromskyi</SelectItem>
          <SelectItem value="2">Bohdan Buryi</SelectItem>
          <SelectItem value="3">Vlad Dev</SelectItem>
          <SelectItem value="4">Nastya Tishchenko</SelectItem>
        </SelectContent>
      </Select>

      {/* Billable Filter */}
      <Select
        value={filters.billable}
        onValueChange={(value) => onFiltersChange({ ...filters, billable: value })}
      >
        <SelectTrigger className="w-full md:w-[150px]">
          <SelectValue placeholder="All Types" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="billable">Billable</SelectItem>
          <SelectItem value="non_billable">Non-billable</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default TimeFilters;
